import {useRuntimeConfig} from '#imports';

/**
 * Return the current App backend prefix url
 *
 * @example for profile-front
 * ```ts
 * const backendUrl = useBackendUrl();
 * console.log(backendUrl); // /profile
 * ```
 */
export function useBackendUrl(): string {
    const config = useRuntimeConfig();
    let baseUrl = config.app.baseURL;
    if (config.public.backendUrl) {
        baseUrl = config.public.backendUrl;
    }
    return baseUrl.replace(/\/+$/, '');
}
